import { render, staticRenderFns } from "./PasswordEdit.vue?vue&type=template&id=40510163&scoped=true&"
import script from "./PasswordEdit.vue?vue&type=script&lang=ts&"
export * from "./PasswordEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordEdit.vue?vue&type=style&index=0&id=40510163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40510163",
  null
  
)

export default component.exports